/* Stylesheet */

.date_restriction {
  display: flex;
  width: 100%;
}
